import { render, staticRenderFns } from "./CompanyComplaintDelegate.vue?vue&type=template&id=c1f87d08&"
import script from "./CompanyComplaintDelegate.vue?vue&type=script&lang=js&"
export * from "./CompanyComplaintDelegate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports